import { isAvailable, FDealType, FOfferType } from '../../../../../../../packages/JsonQuery';
import { IFilterSet, TAllFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.FlatShared;

export const FLAT_SHARED_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailable(FDealType.Sale, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'price',
      'withNeighbors',
      'isOwner',
      'undergroundTime',
      'squareMeterArea',
      'flatRooms',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'kitchenStove',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'saleType',
      'electronicTrading',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
